export default "__VITE_ASSET__CxG34Lnh__"